import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { RioWebClientEventServiceClient } from '@chegg/rio-grpc-interfaces-web-client';
import HostNameClient from '../https';
import EnrichmentManager from '../../enrich/enrichManager';
import { sendGrpcEvent } from '../../events/sendEvent';
import { HTTPS_PREFIX, INIT_CLIENT_LOGGING_KEY, NULL, RETRIES, SEND_EVENT_LOGGING_KEY, Severity, UNDEFINED } from '../../types';
import { isSessionActive, Logger, retryOperation } from '../../utils';
import EventsQueue from '../../utils/EventsQueue';
import { captureError } from '../../utils/newRelicLogging';
var GrpcRioClient = /*#__PURE__*/_createClass(function GrpcRioClient() {
  var _this = this;
  _classCallCheck(this, GrpcRioClient);
  _defineProperty(this, "hostNameClient", new HostNameClient());
  _defineProperty(this, "enrichmentManager", void 0);
  _defineProperty(this, "primaryRioWebClientEventServiceClient", void 0);
  _defineProperty(this, "secondaryRioWebClientEventServiceClient", void 0);
  _defineProperty(this, "eventsQueue", void 0);
  // init the client
  _defineProperty(this, "initClient", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _this.setGrpcClient();
        case 2:
          Logger.info('client initialised');
          // if events exists in local storate then pop
          _context.prev = 3;
          _context.next = 6;
          return _this.executeAllQueueEvents();
        case 6:
          _context.next = 12;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](3);
          // if 3 times retry for current event fails or executeAllQueueEvents
          message = "initClient Last Retry :: ".concat(_context.t0, " primaryHostName: ").concat(_this.hostNameClient.primaryHostName, " secondaryHostName: ").concat(_this.hostNameClient.secondaryHostName, " isInit: ").concat(GrpcRioClient.isInit, " eventsQueue: ").concat(JSON.stringify(_this.eventsQueue, null, ' '));
          captureError({
            error: message,
            location: INIT_CLIENT_LOGGING_KEY,
            severity: Severity.ERROR
          }, {
            message: message
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 8]]);
  })));
  _defineProperty(this, "getGrpcAddress", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(retries) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.hostNameClient.validateLocalStorageSessionId(retries);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  // set grpc client, this will be called at the time of init
  // and if client dont have hostnames and an event is entered
  _defineProperty(this, "setGrpcClient", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var retries,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          retries = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : RETRIES;
          _context3.next = 3;
          return _this.getGrpcAddress(retries);
        case 3:
          if (_this.hostNameClient.primaryHostName && _this.hostNameClient.primaryHostName !== UNDEFINED && _this.hostNameClient.primaryHostName !== NULL) {
            _this.primaryRioWebClientEventServiceClient = new RioWebClientEventServiceClient(HTTPS_PREFIX + _this.hostNameClient.primaryHostName, null, null);
          }
          if (_this.hostNameClient.secondaryHostName && _this.hostNameClient.secondaryHostName !== UNDEFINED && _this.hostNameClient.secondaryHostName !== NULL) {
            _this.secondaryRioWebClientEventServiceClient = new RioWebClientEventServiceClient(HTTPS_PREFIX + _this.hostNameClient.secondaryHostName, null, null);
          }
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
  // execute all events, if no error occured then pop it from front of the queue
  _defineProperty(this, "executeAllQueueEvents", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(!_this.eventsQueue.isEmpty() && (_this.hostNameClient.primaryHostName && _this.hostNameClient.primaryHostName !== UNDEFINED && _this.hostNameClient.primaryHostName !== NULL || _this.hostNameClient.secondaryHostName && _this.hostNameClient.secondaryHostName !== UNDEFINED && _this.hostNameClient.secondaryHostName !== NULL))) {
            _context4.next = 6;
            break;
          }
          _context4.next = 3;
          return retryOperation({
            operation: sendGrpcEvent,
            params: _objectSpread({
              primaryRioWebClientEventServiceClient: _this.primaryRioWebClientEventServiceClient,
              secondaryRioWebClientEventServiceClient: _this.secondaryRioWebClientEventServiceClient
            }, _this.eventsQueue.peek())
          });
        case 3:
          _this.eventsQueue.remove();
          _context4.next = 0;
          break;
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })));
  /* eslint-disable */
  _defineProperty(this, "sendEvent", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(eventType, eventData, view) {
      var isRedirectInSameTabEvent,
        message,
        _args5 = arguments;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            isRedirectInSameTabEvent = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;
            // while adding event to queue, capturing
            // enriched data snapshot and saving

            if (view) _this.updateView(view);
            _this.eventsQueue.add(eventType, eventData, _this.enrichmentManager);
            if (!((!_this.hostNameClient.primaryHostName || _this.hostNameClient.primaryHostName === UNDEFINED || _this.hostNameClient.primaryHostName === NULL) && (!_this.hostNameClient.secondaryHostName || _this.hostNameClient.secondaryHostName === UNDEFINED || _this.hostNameClient.secondaryHostName === NULL))) {
              _context5.next = 6;
              break;
            }
            _context5.next = 6;
            return _this.setGrpcClient(1);
          case 6:
            _context5.prev = 6;
            if (isRedirectInSameTabEvent) {
              _context5.next = 10;
              break;
            }
            _context5.next = 10;
            return _this.executeAllQueueEvents();
          case 10:
            _context5.next = 16;
            break;
          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](6);
            // if 3 times retry for current event fails or executeAllQueueEvents
            message = "sendEvent Last Retry :: ".concat(_context5.t0, " primaryHostName: ").concat(_this.hostNameClient.primaryHostName, " secondaryHostName: ").concat(_this.hostNameClient.secondaryHostName, " isInit: ").concat(GrpcRioClient.isInit, " eventsQueue: ").concat(JSON.stringify(_this.eventsQueue, null, ' '));
            captureError({
              error: message,
              location: SEND_EVENT_LOGGING_KEY,
              severity: Severity.ERROR
            }, {
              message: message
            });
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[6, 12]]);
    }));
    return function (_x2, _x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }());
  /* eslint-enable */
  _defineProperty(this, "updateView", function (view) {
    // view is passed by reference
    var viewClone = _objectSpread({}, view);
    _this.enrichmentManager.setViewProperties(viewClone);
  });
  this.eventsQueue = new EventsQueue();
  this.initClient();
  this.enrichmentManager = new EnrichmentManager();
});
_defineProperty(GrpcRioClient, "isInit", false);
// will check if last session is active
// If not, will create a new
// MANDATORY: checking should be done before constructor is called
// as events before client is initialised will leverage that
_defineProperty(GrpcRioClient, "isLastSessionActive", isSessionActive());
export default GrpcRioClient;